export const TRANSFER_TYPE = {
  STANDARD_ACH: {
    title: 'Typically arrives in 2 to 4 business days',
    value: 'Standard ACH'
  },
  SAME_DAY_ACH: {
    title: 'Typically arrives in 1 to 3 business days',
    value: 'Same Day ACH'
  },
  WIRE: {
    title: 'Same day if before 3pm EST',
    value: 'Wire (Domestic)'
  }
};

export const WHICH_ACCOUNT_STEP = 'WHICH_ACCOUNT_STEP';
export const CHECK_CARD_ERRORS_STEP = 'CHECK_CARD_ERRORS_STEP';
export const HOW_MUCH_STEP = 'HOW_MUCH_STEP';
export const IS_THAT_CORRECT_STEP = 'IS_THAT_CORRECT_STEP';
export const IS_THAT_CORRECT_ACH_STEP = 'IS_THAT_CORRECT_ACH_STEP';
export const IS_THAT_CORRECT_WIRE_STEP = 'IS_THAT_CORRECT_WIRE_STEP';
export const CHOOSING_TRANSFER_TYPE = 'CHOOSING_TRANSFER_TYPE';
export const CONFIRMATION_FORM_STEP = 'CONFIRMATION_STEP';

export const MOVE_MONEY_STEPS_WITHOUT_CHOOSING_TYPE = [
  WHICH_ACCOUNT_STEP,
  HOW_MUCH_STEP,
  IS_THAT_CORRECT_STEP
];

export const MOVE_MONEY_DEPOSIT_STEPS = [
  WHICH_ACCOUNT_STEP,
  HOW_MUCH_STEP,
  IS_THAT_CORRECT_STEP,
  CONFIRMATION_FORM_STEP
];

export const MOVE_MONEY_STEPS_WITH_ACH_TYPE = [
  WHICH_ACCOUNT_STEP,
  HOW_MUCH_STEP,
  IS_THAT_CORRECT_ACH_STEP,
  CONFIRMATION_FORM_STEP
];

export const MOVE_MONEY_STEPS_WITH_WIRE_TYPE = [
  WHICH_ACCOUNT_STEP,
  HOW_MUCH_STEP,
  IS_THAT_CORRECT_WIRE_STEP,
  CONFIRMATION_FORM_STEP
];

export const MOVE_MONEY_TYPE = {
  DEPOSIT: 'deposit',
  WITHDRAW: 'withdrawal',
  TRANSFER: 'transfer'
};

export const AMOUNT_FIELD = 'amount';
export const FROM_FIELD = 'from';
export const FROM_FIELD_ID = 'fromId';
export const FROM_FIELD_NAME = 'fromName';
export const FROM_FIELD_ACCOUNT_NUMBER = 'fromAccountNumber';
export const TO_FIELD = 'to';
export const TO_FIELD_ID = 'toId';
export const TO_FIELD_NAME = 'toName';
export const TO_FIELD_ACCOUNT_NUMBER = 'toAccountNumber';
export const TRANSFER_TYPE_FIELD = 'transferType';
export const DATE_FIELD = 'date';

export const WAIT_FOR_LIST_RENDER = 1000;
export const NUMBER_OF_ACCOUNTS_TO_SHOW = 3;

export const UNIT_STATUS_REASON = {
  COUNTERPARTY_INSUFFICIENT_FUNDS: 'counterparty_insufficient_funds'
};

export const MAP_UNIT_STATUS_TO_ZENBUSINESS_RESPONSE = {
  insufficient_funds: 'There are not enough funds in the account to cover the transaction.',
  daily_ach_credit_limit_exceeded: 'The payment amount exceeds the total daily ACH limit.',
  daily_ach_debit_limit_exceeded: 'The debit payment amount exceeds the total daily ACH limit.',
  daily_wire_limit_exceeded: 'The debit payment amount exceeds the total daily Wire limit.',
  monthly_ach_credit_limit_exceeded:
    'The credit payment amount exceeds the total monthly ACH limit.',
  monthly_ach_debit_limit_exceeded: 'The debit payment amount exceeds the total monthly ACH limit.',
  monthly_wire_limit_exceeded: 'The debit payment amount exceeds the total monthly Wire limit.',
  counterparty_insufficient_funds:
    "The payment did not go through because there weren't enough funds in the other party's account.",
  plaid_balance_unavailable: "We could not access the other party's account balance.",
  plaid_login_required:
    'This link has expired, so you need to log in again. For a new link, see this guide.',
  plaid_invalid_product:
    'We cannot support this financial institution yet. Please contact customer support for more info.',
  plaid_unsupported_bank:
    'We cannot support this financial institution yet. Please contact customer support for more info.',
  plaid_internal_error:
    'There was an error connecting to Plaid. Please contact customer support for more info.'
};

export const MAP_WIRE_STATUS_TO_ZENBUSINESS_RESPONSE = {
  account_frozen: 'Recipient’s account is frozen.',
  suspected_fraud: 'Payment looks fraudulent.',
  insufficient_funds: 'Available balance does not cover the wire amount.',
  invalid_routing_number: 'Recipient’s routing number is not valid.',
  wire_rejected: 'Recipient rejected this payment.',
  account_closed: 'Recipient’s account has been closed.',
  client_request: 'Recipient’s bank rejected this payment.'
};

export const MOVE_MONEY_AGREEMENT = {
  LINE_1:
    'By clicking the Authorize button to continue this transaction, I authorize ZenBusiness to debit the following amount from my bank account on the date shown above.',
  LINE_2:
    'Transactions made after 3:00 PM ET or on a weekend or holiday will be processed the next business day. It is recommended that you print a copy of this authorization for your records.',
  LINE_3: 'Once I authorize this payment, I understand there cannot be any changes or corrections.'
};

export const TIME_LINE = {
  SAME_DAY_ACH: '1 - 3 business days',
  STANDARD_ACH: '2 - 4 business days',
  WIRE: 'Instant - 1 day',
  INSTANT: 'Instant'
};
